// extracted by mini-css-extract-plugin
export default {"PopoverContainer":"OperationalCostsDetails_PopoverContainer__4twwz"};